import React from "react"
//import { Script } from "gatsby"
import SimpleLocalize from "./SimpleLocalize"

const Layout = props => {
  return <SimpleLocalize {...props}>{props.children}</SimpleLocalize>
}
export default Layout
